import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonDirectives } from '@app/shared/directives/common-directives';

@Component({
  selector: 'app-remove-button',
  imports: [CommonDirectives, MatIconModule],
  templateUrl: './remove-button.component.html',
  styleUrl: './remove-button.component.scss'
})
export class RemoveButtonComponent {
  @Output() onRemove = new EventEmitter<void>();

  onClick() {
    this.onRemove.emit();
  }
}
